export default __webpack_public_path__ + "static/media/logox1.6.469b2109.svg";